import { useState, useEffect, useRef, useCallback, useLayoutEffect } from 'react';    
import SandhillsReCAPTCHA from '@Components/Shared/SandhillsReCAPTCHA';   
import TranslationText from '@Components/Utilities/TranslationText';
import translator from '@Components/Utilities/Translator';
import { sandhillsRequest, gtmPushEvent, getGtmEvent, getDateString, insertURLParameter, focusErroredField, logSAMError, criteoPushConversion } from '@Components/Utilities/SandhillsUtility';
import { ValidationRules, ruleRunner, run } from '@Components/Utilities/Validation';
import ValidationErrors from '@Components/Shared/ValidationErrors';
import debounce from 'lodash/debounce';
import { inquiryType, contactType, gtmEventType } from '@Components/Utilities/SandhillsConstants';
import TextField from '@Components/Shared/Controls/TextField';
import MUITextField from '@mui/material/TextField';
import SelectField from '@Components/Shared/Controls/SelectField';
import CurrencySelector from '@Components/Shared/CurrencySelector';
import LoadingRing from '@Components/MuiWrappers/LoadingRing';
import Modal from '@Components/Shared/Modals/Modal';
import { getUserPosition } from '@Components/Utilities/Geolocation';
import ready from 'document-ready';
import intlTelInput from 'intl-tel-input';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import 'intl-tel-input/build/css/intlTelInput.css';
import '@Styles/vendors-extensions/_intl-tel-input.scss';
import Button from '@mui/material/Button';
import Grid from '@mui/material/Grid';
import Tooltip from '@mui/material/Tooltip';
import CheckIcon from '@mui/icons-material/Check';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import InputAdornment from '@mui/material/InputAdornment';
import { parseScriptTagsAsync } from '@Components/Utilities/ChallengeHelper';

import {
    TwitterShareButton,
    FacebookShareButton,
    LinkedinShareButton,
    WhatsappShareButton,
    FacebookMessengerShareButton,
    EmailShareButton,
} from 'react-share';

const EmailModal = (props) => {

    const recaptchaRef = useRef(null);
    const [captchaOpen, setCaptchaOpen] = useState(false);
    const currentSite = useRecoilValue(atoms.currentWebsite);
    const currentUser = useRecoilValue(atoms.currentUser);
    const routes = useRecoilValue(atoms.routes);
    const [firstName, setFirstName] = useState(props.FirstName || '');
    const [lastName, setLastName] = useState(props.LastName || '');
    const [email, setEmail] = useState(props.Email || '');
    const [isEmailValid, setIsEmailValid] = useState(props.Email ? true : false);
    const [emailSuggestion, setEmailSuggestion] = useState('');
    const [recipientEmail, setRecipientEmail] = useState(props.RecipientEmail || '');
    const [comments, setComments] = useState('');
    const [phone, setPhone] = useState(props.Phone || '');
    const [postalCode, setPostalCode] = useState(props.PostalCode || '');
    const [country, setCountry] = useState(props.Country || '');
    const [videoChatService, setVideoChatService] = useState('');
    const [videoChatTime, setVideoChatTime] = useState('');
    const [videoChatDay, setVideoChatDay] = useState('');
    const [emailSubAndAcknowledgement, setEmailSubAndAcknowledgement] = useState(props.EmailSubAndAcknowledgement);
    const [inquiryTypeId, setInquiryTypeId] = useState(typeof (props.selectedInquiry) === 'number' ? props.selectedInquiry : null);
    const [offerAmount, setOfferAmount] = useState(props.OfferAmount);
    const [offerCurrency, setOfferCurrency] = useState(props.OfferCurrency);
    const [success, setSuccess] = useState(false);
    const [message, setMessage] = useState('');
    const [disableModal, setDisableModal] = useState(false);
    const [disableSubmit, setDisableSubmit] = useState(false);
    const [validationErrors, setValidationErrors] = useState({});
    const inquiryOptions = props.Inquiries && props.Inquiries.filter(inquiry => !inquiry.HideInDropdown).map(inquiry => ({ Value: inquiry.ID, Text: inquiry.Name }));
    const [coordinate, setCoordinate] = useState({ latitude: props.Latitude, longitude: props.Longitude });
    const inputReferences = useRef({});
    const sitePhoneFormatCultureCode = useRecoilValue(atoms.sitePhoneFormatCultureCode);
    const [EmailFieldsVisible, setEmailFieldsVisible] = useState(false);
    const [linkCopied, setLinkCopied] = useState(false);
    const [shortLinkCopied, setShortLinkCopied] = useState(false);
    const [hideSocialButtons, setHideSocialButtons] = useState(false);
    const emailError = translator.translate('sandhills.emailinimproperformat');
    const [shortURL, setShortURL] = useState('');
    const assemblyFormRef = useRef(null);
    const hasListingsInput = props.ListingsInputURL && props.ListingsInputURL.length > 0;

    useEffect(() => {
        if (props.HasFormAssembly && assemblyFormRef.current) {
            const tfa = assemblyFormRef.current;

            if (tfa && tfa.innerHTML !== '') {
                tfa.innerHTML = tfa.innerHTML.replace(/<script\b([^>]*)>/gi, (match, attrs) => {
                    // If priority already exists, do not add again
                    if (/priority\s*=\s*["']?\d+["']?/i.test(attrs)) {
                        return match;
                    }
                    return `<script${attrs} priority="3">`; //set scripts execution order when invoked by parseScriptTagsAsync()
                });

                tfa.innerHTML += `<script type="text/javascript" priority="4">document.dispatchEvent(new CustomEvent("FA__DOMContentLoaded"));</script>`; 
                parseScriptTagsAsync(tfa);
            }

            const faForm = tfa.getElementsByTagName('form');  
         
            if (faForm && faForm.length > 0) {
                const form = faForm[0];

                form.addEventListener('submit', function (event) {
                    event.preventDefault();
                });

                //form.validation.formassembly is dispatched by Volvo's wforms.js 
                form.addEventListener('form.validation.formassembly', function (event) {
                    if (event.detail.statusText == 'passed') { 
                        const formData = new FormData(form);

                        fetch(form.action, {
                            method: form.method,
                            body: formData,
                        })
                        .then(response => {
                            if (response.ok) {
                                return response.text();
                            }
                            throw new Error('Network response was not ok.');
                        })
                        .then(text => {
                            document.getElementById('formFill').innerHTML = text;
                        });
                    }
                }, true);
            } 
        }
    }, [assemblyFormRef, props.FormAssembly]);

    useEffect(() => {
        if (props.ListingID) {
            gtmPushEvent(gtmEventType.emailModalOpen);
        }
        if (props.PostalCode) {
            postalCodeAjax({ 'postalCode': props.PostalCode });
        }

        let inquiry = getSelectedInquiry(props.selectedInquiry);
        let defaultComment = getInquiryComment(inquiry);

        setComments(defaultComment);
        getSubmitLocation();

        if (props.selectedInquiry == inquiryType.CheckAvailability) {
            gtmPushEvent('check-availability-click');
        }

        ready(() => {
            if (!currentUser.IsAuthenticated) {
                const phoneElement = document.querySelector('.send-a-message #phone');
                if (phoneElement) {
                    intlTelInput(phoneElement, {
                        autoHideDialCode: false,
                        autoPlaceholder: 'off',
                        nationalMode: false,
                        separateDialCode: true,
                        preferredCountries: ['us', 'gb', 'ca'],
                        initialCountry: sitePhoneFormatCultureCode ? sitePhoneFormatCultureCode.substring(sitePhoneFormatCultureCode.length - 2) : 'us'
                    });
                }
            }

            const postalCodeElement = document.querySelector('.send-a-message #postalCode');

            if (postalCodeElement) {
                const postalIti = intlTelInput(postalCodeElement, {
                    autoPlaceholder: 'off',
                    nationalMode: true,
                    separateDialCode: false,
                    preferredCountries: ['us', 'gb', 'ca'],
                    initialCountry: props.Country ? props.Country.substring(props.Country.length - 2) : sitePhoneFormatCultureCode ? sitePhoneFormatCultureCode.substring(sitePhoneFormatCultureCode.length - 2) : 'us'
                });
                postalCodeElement.closest('.iti')?.classList.add('iti--postal-code');
                let currentPostalCountry = postalIti.getSelectedCountryData()?.iso2 || '';

                // This is to address an issue where the postal code country dropdown would change the country on the phone input. 
                // We want to only allow changing the postal code country when the user explicitly changes it.
                setCountry(currentPostalCountry);
                let isPostalDropdownOpen = false;
                postalCodeElement.addEventListener('open:countrydropdown', () => {
                    isPostalDropdownOpen = true;
                });
                postalCodeElement.addEventListener('close:countrydropdown', () => {
                    setTimeout(() => {
                        isPostalDropdownOpen = false;
                    }, 0);
                });
                postalCodeElement.addEventListener('countrychange', () => {
                    const newCountry = postalIti.getSelectedCountryData()?.iso2 || '';
                    if (isPostalDropdownOpen) {
                        currentPostalCountry = newCountry;
                        setCountry(currentPostalCountry);
                    } else {
                        postalIti.setCountry(currentPostalCountry);
                    }
                });
            }

        });

        setTimeout(() => {
            setValidationErrors({});
        }, 50);

        if (props.ListingSourceDomainUrl) {
            const privacyPolicyText = document.getElementById('privacy-policy-text');
            if (privacyPolicyText?.children?.length > 0) {
                for (let i = 0; i < privacyPolicyText.children.length; i++) {
                    privacyPolicyText.children[i]?.querySelectorAll?.('a[href^="/"]')?.forEach?.((el) => {
                        el?.setAttribute?.('href', props.ListingSourceDomainUrl + el?.getAttribute?.('href'));
                    });
                }
            }
        }
    }, []);

    const submitForm = (e) => {
        e.preventDefault();
        let rules = [
            ruleRunner('firstName', translator.translate('sandhills.tradepubwebsite.mvc.firstname'), ValidationRules.required),
            ruleRunner('lastName', translator.translate('sandhills.tradepubwebsite.mvc.lastname'), ValidationRules.required),
            ruleRunner('email', translator.translate('sandhills.email'), ValidationRules.validEmail),
            ruleRunner('phone', translator.translate('sandhills.phone'), ValidationRules.requiredIf(props.selectedInquiry != inquiryType.EmailThis)),
            ruleRunner('postalCode', translator.translate('sandhills.postalcode')),
            ruleRunner('country', translator.translate('sandhills.country')),
            ruleRunner('inquiryTypeId', translator.translate('sandhills.inquiry'), ValidationRules.requiredIf(typeof (props.selectedInquiry) === 'number')),
            ruleRunner('offerAmount', translator.translate('sandhills.listings.enterofferamount'), ValidationRules.requiredIf(props.selectedInquiry == inquiryType.Offer)),
            ruleRunner('videoChatService', translator.translate('sandhills.videochatservice'), ValidationRules.requiredIf(props.selectedInquiry == inquiryType.VideoChat)),
            ruleRunner('videoChatTime', 'Time', ValidationRules.requiredIf(props.selectedInquiry == inquiryType.VideoChat)),
            ruleRunner('videoChatDay', 'Day', ValidationRules.requiredIf(props.selectedInquiry == inquiryType.VideoChat)),
            ruleRunner('comments', translator.translate('sandhills.tradepubwebsite.mvc.message'), ValidationRules.requiredIf(props.selectedInquiry != inquiryType.Offer))
        ];

        if (props.selectedInquiry == inquiryType.EmailThis) {
            rules.push(ruleRunner('recipientEmail', translator.translate('sandhills.recipientsemail'), ValidationRules.validEmail))
        }
        if (props.IsPreAT && !displayInquiryElement(inquiryType.VideoChat)) {
            rules.push(ruleRunner('offerAmount', translator.translate('sandhills.tradesites.mvc.offeramount'), ValidationRules.required));
        }

        let errors = run({
            firstName: firstName,
            lastName: lastName,
            email: email,
            phone: phone,
            postalCode: postalCode,
            country: country,
            inquiryTypeId: inquiryTypeId,
            offerAmount: offerAmount,
            videoChatService: videoChatService,
            videoChatTime: videoChatTime,
            videoChatDay: videoChatDay,
            comments: comments,
            recipientEmail: recipientEmail
        }, rules);

        if (props.EmployeeEmail && props.EmployeeEmail.toLowerCase() !== email.toLowerCase()) {
            errors.comments = ('Please use the email address: ' + props.EmployeeEmail + ' to reduce the risk of having your message blocked by security measures.');
        }

        if (!emailSubAndAcknowledgement.PrivacyPolicyAccepted && emailSubAndAcknowledgement.PrivacyPolicyStatementVisible) {
            errors['PrivacyPolicyAccepted'] = translator.translate('sandhills.required').toString();
        }

        if (emailSubAndAcknowledgement.RequireEmailSubCheckbox && !emailSubAndAcknowledgement.SubscribeToWeeklyUpdate) {
            errors['SubscribeToWeeklyUpdate'] = translator.translate('sandhills.required').toString();
        }

        setValidationErrors(errors);
        focusErroredField(errors, inputReferences);

        if (Object.keys(errors).length <= 0) {
            setDisableModal(true);
            if (props.Captcha && recaptchaRef.current) {
                setCaptchaOpen(true);
                recaptchaRef.current.execute();
            } else {
                onSubmit();
            }
        }
    };

    const setEmailValidationDebounced = useCallback(debounce((e) => validateEmail(e), 750), []);

    const fireSendAMessageError = (inquiry, contact, data, isShowroomfailure) => {
        const errorData = {
            CRMID: data?.DealerCRMID,
            DealerGroupID: data?.DealerGroupID,
            ListingBaseCatID: data?.ListingBaseCatID,
            ListingCategoryID: data?.ListingCategoryID,
            ListingID: data?.ListingID,
            ListingManufacturer: data?.ListingManufacturer,
            ListingModel: data?.ListingModel,
            ListingSourceDomainUrl: data?.ListingSourceDomainUrl,
            ListingURL: data?.ListingURL,
            ModalTitle: data?.ModalTitle,
            Subject: data?.Subject,
            IsShowroom: data?.IsShowroom,
            ListingURL: props.ListingURL
        }

        let msg = `Error on SAM Modal submission in EmailModal.jsx: \r\nInquiry: ${inquiry} \r\nContact: ${contact} \r\nShowroom Failure: ${isShowroomfailure} \r\nData: ${JSON.stringify(errorData)}`;
        logSAMError(routes.LogSendAMessageError, msg);
    }

    let closeTimeoutId = useRef(null);
    const onSubmit = (token) => {
        var dialCode = document.querySelector('.send-a-message #phone')?.closest('.iti')?.querySelector('.iti__selected-dial-code')?.textContent || "";

        if (props.selectedInquiry != inquiryType.EmailThis && !props.IsFBO && (!props?.ListingID || props?.ListingID == 0) && (!props?.JobListingID || props?.JobListingID == 0) && ((!props?.DealerGroupID || props?.DealerGroupID == 0) && !props.IsGeneralOverride)) {
            setDisableModal(false);
            setSuccess(false);
            setMessage('Message failed to send, please try again. If you continue to have issues please <a href="/info/contact-us">contact us</a>.');
        } else {
            if (props.selectedInquiry != inquiryType.EmailThis && !props.IsFBO && ((!props?.DealerGroupID || props?.DealerGroupID == 0) && !props.IsGeneralOverride) && (!props?.ListingID || props?.ListingID == 0)) {
                fireSendAMessageError(props.selectedInquiry, props.selectedContactType, props);
            }
            if (props.ListingURL?.includes('settingscrmid=') && props.ListingURL?.includes('IsShowroom=1') && !props.IsShowroom) {
                fireSendAMessageError(props.selectedInquiry, props.selectedContactType, props, true);
            }

            sandhillsRequest({
                url: getSubmitAction(),
                method: 'post',
                data: {
                    Subject: props.Subject || '',
                    FirstName: firstName,
                    LastName: lastName,
                    Email: email,
                    IsEmailValid: isEmailValid,
                    RecipientEmail: recipientEmail,
                    Comments: comments,
                    Phone: dialCode + phone,
                    PostalCode: postalCode,
                    Country: country,
                    DealerCRMID: props.useWholesaleOverride && props.WholesaleCRMID ? props.WholesaleCRMID : props.DealerCRMID,
                    DealerGroupID: props.useWholesaleOverride && props.WholesaleDG ? props.WholesaleDG : props.DealerGroupID,
                    BranchName: props.BranchName,
                    DealerLocation: props.DealerLocation,
                    DealerPhone: props.DealerPhone,
                    DealerContact: props.DealerContact,
                    ListingManufacturer: props.ListingManufacturer,
                    ListingModel: props.ListingModel,
                    ListingAltCategoryID: props.ListingAltCategoryID,
                    ListingBaseCatID: props.ListingBaseCatID,
                    ListingCategoryID: props.ListingCategoryID,
                    ListingID: props.ListingID,
                    MediaID: props.MediaID,
                    ListingType: props.ListingType,
                    ListingCondition: props.ListingCondition,
                    ModalType: getModalType(),
                    SerialNumber: props.SerialNumber,
                    Price: props.Price,
                    WholeSalePrice: props.WholeSalePrice,
                    IsExclusiveWholesale: props.IsExclusiveWholesale,
                    ListingURL: props.ListingURL,
                    IsShowroom: props.IsShowroom,
                    IsParts: props.IsParts,
                    IsForRentOnly: props.IsForRentOnly,
                    IsJobListing: props.IsJobListing,
                    PartsSource: props.PartsSource || '',
                    VideoChatService: videoChatService,
                    VideoChatTime: videoChatTime,
                    VideoChatDay: videoChatDay,
                    SelectedContactType: props.selectedContactType,
                    EmailSubAndAcknowledgement: {
                        WeeklyUpdateVisible: emailSubAndAcknowledgement.WeeklyUpdateVisible,
                        PrivacyPolicyStatementVisible: emailSubAndAcknowledgement.PrivacyPolicyStatementVisible,
                        SubscribeToWeeklyUpdate: emailSubAndAcknowledgement.SubscribeToWeeklyUpdate,
                        PrivacyPolicyAccepted: emailSubAndAcknowledgement.PrivacyPolicyAccepted,
                        PixelsPolicyStatementVisible: emailSubAndAcknowledgement.PixelsPolicyStatementVisible,
                        PixelsPolicyAccepted: emailSubAndAcknowledgement.PixelsPolicyAccepted,
                        WebAgreementTypeIDs: emailSubAndAcknowledgement.WebAgreementTypeIDs,
                        Context: emailSubAndAcknowledgement.Context || getModalType()
                    },
                    InquiryTypeID: inquiryTypeId,
                    OfferAmount: offerAmount,
                    OfferCurrency: offerCurrency,
                    Longitude: coordinate.longitude,
                    Latitude: coordinate.latitude,
                    IsPreTrade: props.IsPreTrade,
                    Captcha: {
                        Response: token
                    },
                    IsPreATLead: props.IsPreAT,
                    IsWholesaleLead: props.IsWholeSale,
                    SourceURL: window.location.href
                },
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then((response) => {
                if (response) {
                    if (response.success) {
                        let tagManagerEvent = getGoogleTagManagerEvent();

                        if (tagManagerEvent) {
                            gtmPushEvent(tagManagerEvent);
                        }

                        criteoPushConversion({ ...props, EquipmentMessageID: response.EquipmentMessageID, PostalCode: postalCode });
                        setDisableModal(false);
                        setSuccess(true);
                        setMessage(response.message);
                        if (!hasListingsInput && !props.ShowVIP) {
                            closeTimeoutId.current = setTimeout(() => props.toggleEmailModal(), 3000);
                        }
                    } else {
                        setDisableModal(false);
                        setSuccess(false);
                        setMessage(response.message);

                        if (props.Captcha && recaptchaRef.current) {
                            setCaptchaOpen(false);
                            recaptchaRef.current.reset();
                        }
                    }
                }
            });
        }
    };

    const onClose = () => {
        if (closeTimeoutId.current) {
            clearTimeout(closeTimeoutId.current);
        }
        setValidationErrors({});
        props.toggleEmailModal(props.Ref);
    };

    const getGoogleTagManagerEvent = () => {
        let inquiry;
        if (inquiryTypeId == null) {
            inquiry = props.selectedInquiry;
        } else {
            inquiry = inquiryTypeId;
        }
        return getGtmEvent(inquiry);
    };

    const isIOSDevice = () => {
        return /iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
    };

    const getVideoChatServices = () => {
        // Removed "Android" reference to comply with 2.3.10 Apple Store Guideline - TOID:74417972
        var services = [
            { Value: '', Text: translator.translate('Sandhills.CRM.DSCRM.Service') },
            { Value: 'Apple', Text: 'Apple' },
            { Value: 'Android', Text: 'Android' },
            { Value: 'Other', Text: translator.translate('sandhills.tradepubwebsite.mvc.other') }
        ];

        if (currentSite.IsMobileAppContext && isIOSDevice()) {
            services = services.filter(x => x.Value !== 'Android');
        }

        return services;
    };

    const getVideoChatTimes = () => {
        return [
            { Value: '', Text: translator.translate('Sandhills.Time') },
            { Value: '8am–12pm', Text: props.Use24HrsFormat ? '8:00–12:00' : '8am–12pm' },
            { Value: '12pm–3pm', Text: props.Use24HrsFormat ? '12:00–15:00' : '12pm–3pm' },
            { Value: '3pm–6pm', Text: props.Use24HrsFormat ? '15:00–18:00' : '3pm–6pm' }
        ];
    };

    const getVideoChatDays = () => {
        return [
            { Value: '', Text: translator.translate('Sandhills.Day') },
            { Value: getDateString(0), Text: getDateString(0, true) },
            { Value: getDateString(1), Text: getDateString(1, true) },
            { Value: getDateString(2), Text: getDateString(2, true) }
        ];
    };

    const getSubmitAction = () => {
        let formAction = routes.SendMessage;
        if (props.selectedInquiry == inquiryType.EmailThis) {
            var baseURL = routes.EmailThis;
            baseURL = insertURLParameter(baseURL, 'ListingURL', encodeURIComponent(window.location.href));
            formAction = baseURL;
        }

        if (window.Overrides.isHostedSite) {
            formAction = insertURLParameter(formAction, 'clientSideReferrer', window.location.hostname);
        }

        return formAction;
    };

    const getModalType = () => {
        switch (props.selectedInquiry) {
            case inquiryType.Offer:
                return 'makeAnOffer';
            case inquiryType.EmailThis:
                return 'emailThis';
            case inquiryType.Email:
            default:
                return 'sendAMessage';
        }
    };

    const displayInquiryElement = (inquiry) => inquiry == props.selectedInquiry;

    const getInquiryComment = (inquiry) => {
        if (inquiry) {
            return inquiry.DefaultComment.replace('{0}', props.Subject || '');
        } else {
            return '';
        }
    };

    const getSelectedInquiry = (inquiryId) => {
        let selectedInquiry = null;
        let parsedInquiryId = parseInt(inquiryId);

        if (inquiryId && !isNaN(parsedInquiryId)) {
            selectedInquiry = props.Inquiries.reduce((previous, current) => {
                return current.ID == inquiryId ? current : previous;
            }, null);
        }
        return selectedInquiry;
    };

    const validateEmail = e => {
        let email = e.target ? e.target.value : e;
        if (email) {
            sandhillsRequest({
                url: routes.ValidateEmail,
                method: 'post',
                data: {
                    'sEmail': email
                },
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then((response) => {
                if (response.IsValidEmail) {
                    setIsEmailValid(true);
                    setDisableSubmit(false);
                } else {
                    setIsEmailValid(false);
                    setDisableSubmit(true);
                }

                if (response.DidYouMean) {
                    setEmailSuggestion(response.DidYouMean);
                }
            }).catch(() => {
                setIsEmailValid(true);
                setDisableSubmit(false);
                setEmailSuggestion('');
            });
        }
    };

    const onEmailSuggestionClick = () => {
        setEmail(emailSuggestion);
        setEmailSuggestion('');
        validateEmail(emailSuggestion);
    };

    const postalCodeAjax = (data) => {
        if (emailSubAndAcknowledgement.WeeklyUpdateVisible) {
            sandhillsRequest({
                url: routes.GetPostalCodeByID,
                method: 'post',
                data: data,
                errorHandling: {
                    useConsole: false,
                    useAlert: false
                }
            }).then((response) => {
                let checked = false;
                if (response.StateCode && response.StateCode.toString().toUpperCase() !== 'CA' && response.Country.toString().toUpperCase() === 'USA') {
                    checked = true;
                }
                setEmailSubAndAcknowledgement((previousState) => {
                    return ({ ...previousState, SubscribeToWeeklyUpdate: checked });
                });
            });
        }
    };

    const onEmailSubAndAcknowledgementChange = (e) => {
        let name = e.target.name, checked = e.target.checked;
        setEmailSubAndAcknowledgement((previousState) => {
            return ({ ...previousState, [name]: checked });
        });
        setValidationErrors((previousState) => {
            return ({ ...previousState, [name]: '' });
        });
    };

    const getSubmitLocation = () => {
        getUserPosition(true, null, routes.AjaxSetCurrentUserLocationCookie, routes.AjaxGetDecryptedCoordinatesFromCurrentLocationCookie)
            .then((setCoordinate));
    };

    const resetModal = () => {
        setDisableModal(false);
    };

    const ShareViaEmailButtonClick = () => {
        gtmPushEvent(gtmEventType.emailThis);
        setEmailFieldsVisible(!EmailFieldsVisible);
        setHideSocialButtons(!hideSocialButtons);
    };

    const copyLink = () => {
        navigator.clipboard.writeText(window.location.href)

        setLinkCopied(true);

        setTimeout(() => {
            setLinkCopied(false);
        }, 10000);
    }

    const shortCopy = () => {
        navigator.clipboard.writeText(shortURL)

        setShortLinkCopied(true);

        setTimeout(() => {
            setShortLinkCopied(false);
        }, 10000);
    }

    const BuildShortURL = () => {
        sandhillsRequest({
            url: routes.GetShortURL,
            method: 'post',
            data: {
                fullURL: window.location.href.toString()
            },
            errorHandling: {
                useConsole: true,
                useAlert: false
            }
        }).then((response) => {
            setShortURL(response);
        });
    }

    const shareButtonSx = {
        color: 'white !important ',
        height: '36px',
        borderRadius: '5px',
        minWidth: '50px',
        width: '100%'
    };

    return (
        <Modal containerClassName='send-a-message' onEscapeKeyClose={onClose}>
            {props.HasFormAssembly ?
                <>
                    <Modal.Header onClose={ onClose }>
                    </Modal.Header>
                    <Modal.Body>
                        <div ref={assemblyFormRef} id='formFill' dangerouslySetInnerHTML= {{__html: props.FormAssembly }} />
                    </Modal.Body>
                </>
                :
                <>
                    <Modal.Header onClose={onClose}>
                        <Modal.Title>
                            {props.IsPreAT ?
                                translator.translate('sandhills.tradesites.mvc.preatoffer') + ': ' + props.ModalTitle
                                :
                                (!props.IsPreTrade && props.selectedInquiry != inquiryType.Offer) &&
                                (success ? <h2 className="success-title">{translator.translate('sandhills.thankyou')}</h2> : props.ModalTitle) }
                            {(props.IsWholeSale || props.IsPreTrade) &&
                                <span className='lead-image'>
                                    <br />
                                    {
                                        props.IsPreAT ?
                                            <img className='pre-at' src={routes.CDNBaseUrl + 'Images/Logos/FastTrack/pre-at-logo.png'} aria-hidden={true} /> :
                                            <img src={routes.CDNBaseUrl + 'Images/Logos/FastTrack/fti-logo.png'} aria-hidden={true} />
                                    }
                                </span>}
                            {props.IsPreTrade && props.selectedInquiry == inquiryType.Offer ? translator.translate('sandhills.tradesites.mvc.pretradeoffer') + ": " + props.ModalTitle : props.IsPreTrade && props.ModalTitle}
                        </Modal.Title>
                        {message && <p className={success ? 'success' : 'error'} dangerouslySetInnerHTML={{ __html: message }}></p>}

                        {props.ShowSocialShareButtons && !success &&
                            <>
                                <label htmlFor='copylink'><TranslationText style={{ float: 'left', fontSize: '16px' }} tKey='sandhills.copythislink' /> </label>
                                <Tooltip PopperProps={{ sx: { zIndex: 1600 } }} title={linkCopied ? <TranslationText tKey='sandhills.linkcopied' /> : <TranslationText tKey='sandhills.clicktocopy' />} placement="top">
                                    <MUITextField
                                        id='copylink'
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position='end'>
                                                    {linkCopied ? <CheckIcon /> : <ContentCopyIcon />}
                                                </InputAdornment>
                                            )
                                        }}
                                        inputProps={{
                                            sx: { textAlign: linkCopied ? 'center' : '', cursor: 'text' }
                                        }}
                                        value={linkCopied ? translator.translate('sandhills.linkcopied') : window.location.href}
                                        sx={{ width: '100%', height: '50px', cursor: 'text' }}
                                        onClick={() => { copyLink() }}
                                        variant='outlined'
                                        size='small'
                                        disabled={true}
                                    />
                                </Tooltip>
                                {currentSite.Site.IsHostedSite &&
                                    <>
                                        <Button
                                            id='build-short-url'
                                            variant='contained'
                                            onClick={() => { BuildShortURL(); }}
                                            sx={{ backgroundColor: '#808080 !important', marginBottom: '15px' }}>
                                            {translator.translate('sandhills.tradesites.mvc.generateshorturl')}
                                        </Button>
                                        {shortURL &&
                                            <>
                                                <br />
                                                <label htmlFor='copyshortlink'><TranslationText style={{ float: 'left', fontSize: '16px' }} tKey='sandhills.copythislink' /> </label>
                                                <MUITextField
                                                    id='copyshortlink'
                                                    InputProps={{
                                                        endAdornment: (
                                                            <InputAdornment position='end'>
                                                                {shortLinkCopied ? <CheckIcon /> : <ContentCopyIcon />}
                                                            </InputAdornment>
                                                        )
                                                    }}
                                                    inputProps={{
                                                        sx: { textAlign: shortLinkCopied ? 'center' : '', cursor: 'text' }
                                                    }}
                                                    value={shortLinkCopied ? translator.translate('sandhills.linkcopied') : shortURL}
                                                    sx={{ width: '100%', height: '50px', cursor: 'text' }}
                                                    onClick={() => { shortCopy() }}
                                                    variant='outlined'
                                                    size='small'
                                                    disabled={true}
                                                />
                                            </>
                                        }
                                    </>
                                }
                                {!hideSocialButtons &&
                                    <>
                                        <Grid container spacing={2}>
                                            <Grid item xs={4}>
                                                <Button
                                                    id='facebook-share-this-link'
                                                    startIcon={<i className="fa-brands fa-facebook-f social-share-icon social-share-icon-fa" round></i>}
                                                    url={window.location.href}
                                                    variant='contained'
                                                    component={FacebookShareButton}
                                                    onClick={() => { gtmPushEvent(gtmEventType.FacebookShare); }}
                                                    sx={{ ...shareButtonSx, backgroundColor: '#3b5998 !important' }}>
                                                    Facebook
                                                </Button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    id='twitter-share-this-link'
                                                    startIcon={<i className="fa-brands fa-x-twitter social-share-icon social-share-icon-fa" round></i>}
                                                    url={window.location.href}
                                                    variant='contained'
                                                    component={TwitterShareButton}
                                                    onClick={() => { gtmPushEvent(gtmEventType.TwitterShare); }}
                                                    sx={{ ...shareButtonSx, backgroundColor: '#00aced !important' }}>
                                                    Twitter
                                                </Button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    id='linkedin-share-this-link'
                                                    startIcon={<i className="fa-brands fa-linkedin-in social-share-icon social-share-icon-fa" round></i>}
                                                    url={window.location.href}
                                                    variant='contained'
                                                    component={LinkedinShareButton}
                                                    onClick={() => { gtmPushEvent(gtmEventType.LinkedInShare); }}
                                                    sx={{ ...shareButtonSx, backgroundColor: '#007fb1 !important' }}>
                                                    LinkedIn
                                                </Button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    id='whatsapp-share-this-link'
                                                    startIcon={<i className="fa-brands fa-whatsapp social-share-icon social-share-icon-fa" round></i>}
                                                    url={window.location.href}
                                                    variant='contained'
                                                    component={WhatsappShareButton}
                                                    onClick={() => { gtmPushEvent(gtmEventType.WhatsAppShare); }}
                                                    sx={{ ...shareButtonSx, backgroundColor: '#25D366 !important' }}>
                                                    WhatsApp
                                                </Button>
                                            </Grid>
                                            <Grid item xs={4}>
                                                <Button
                                                    id='messenger-share-this-link'
                                                    startIcon={<i className="fa-brands fa-facebook-messenger social-share-icon social-share-icon-fa" round></i>}
                                                    url={window.location.href}
                                                    variant='contained'
                                                    component={FacebookMessengerShareButton}
                                                    appId={props.FacebookMessengerShareAppID}
                                                    onClick={() => { gtmPushEvent(gtmEventType.MessengerShare); }}
                                                    sx={{ ...shareButtonSx, backgroundColor: '#0695FF !important' }}>
                                                    Messenger
                                                </Button>
                                            </Grid>

                                            <Grid item xs={4}>
                                                <Button
                                                    startIcon={<i className="fa-regular fa-envelope social-share-icon social-share-icon-fa" round></i>}
                                                    variant='contained'
                                                    component={EmailShareButton}
                                                    sx={{ ...shareButtonSx, backgroundColor: '#808080 !important' }}
                                                    onClick={() => ShareViaEmailButtonClick()}>
                                                    <TranslationText tKey='sandhills.shareviaemail' />
                                                </Button>
                                            </Grid>
                                        </Grid>
                                    </>
                                }
                            </>
                        }
                    </Modal.Header>
                    <Modal.Body>
                        {success && 
                            <div class="success-body">
                                {hasListingsInput && !props.IsHostedSite &&
                                    <div class="flex-col">
                                        <strong>{translator.translate('sandhills.tradesites.mvc.readytosell')}</strong>
                                        <p>{translator.translate('sandhills.tradesites.mvc.anyownercanlist')}</p>
                                        <a class="button ts-button" href={props.ListingsInputURL} target="_blank" id="leads-success-listingsinput">{props.ListingsInputText}</a>
                                    </div>    
                                }
                                {props.ShowVIP &&
                                    <div class="flex-col">
                                        <strong>{translator.translate('sandhills.tradesites.mvc.wantafreevaluefirst')}</strong>
                                        <p>{translator.translate('sandhills.tradesites.mvc.logintogetquickvalues')}</p>
                                        <a class="button ts-button vip-button" href={props.VIPURL} target="_blank" id="leads-success-vip">
                                            <img src={props.VIPImage} alt="" aria-describedby="get-values-text" />
                                            <span id="get-values-text">{translator.translate('sandhills.tradesites.mvc.getvalues')}</span>
                                        </a>
                                    </div>
                                }
                            </div>}
                        {(!props.ShowSocialShareButtons || EmailFieldsVisible) && (!props.UseLeadsUXUpdate || (props.UseLeadsUXUpdate && !success)) &&
                            <form className='send-a-message-form' onSubmit={submitForm} noValidate autoComplete="off">
                                <p id='description-label' className='hidden'>Send an email</p>
                                <ValidationErrors errors={validationErrors} />
                                <div className='form-main-content'>
                                    <div className='left-col'>
                                        <TextField
                                            type='text'
                                            id='firstName'
                                            name='firstName'
                                            value={firstName}
                                            required={true}
                                            class='form-el'
                                            label={<TranslationText tKey='sandhills.tradepubwebsite.mvc.firstname' />}
                                            placeholder={translator.translate('sandhills.enteryourfirstname')}
                                            validationErrors={validationErrors.firstName}
                                            ref={(element) => inputReferences.current[`firstName`] = element}
                                            onFieldChanged={(e) => {
                                                setFirstName(e.target.value);
                                                setValidationErrors((previousState) => {
                                                    return ({ ...previousState, firstName: '' });
                                                });
                                            }}
                                        />
                                        <TextField
                                            type='text'
                                            id='lastName'
                                            name='lastName'
                                            value={lastName}
                                            required={true}
                                            class='form-el'
                                            label={<TranslationText tKey='sandhills.tradepubwebsite.mvc.lastname' />}
                                            placeholder={translator.translate('sandhills.enteryourlastname')}
                                            validationErrors={validationErrors.lastName}
                                            ref={(element) => inputReferences.current[`lastName`] = element}
                                            onFieldChanged={(e) => {
                                                setLastName(e.target.value);
                                                setValidationErrors((previousState) => {
                                                    return ({ ...previousState, lastName: '' });
                                                });
                                            }}
                                        />
                                        <TextField
                                            type='text'
                                            id='email'
                                            name='email'
                                            value={email}
                                            required={true}
                                            class='form-el'
                                            label={<TranslationText tKey='sandhills.email' />}
                                            placeholder={translator.translate('sandhills.enteryouremailaddress')}
                                            validationErrors={validationErrors.email || (disableSubmit && emailError)}
                                            ref={(element) => inputReferences.current[`email`] = element}
                                            onFieldChanged={(e) => {
                                                setEmail(e.target.value);
                                                setEmailValidationDebounced(e.target.value);
                                                setValidationErrors((previousState) => {
                                                    return ({ ...previousState, email: '' });
                                                });
                                            }}
                                        />
                                        {emailSuggestion &&
                                            <div id='emailSuggestionWrapper' name='emailSuggestionWrapper' style={{ fontWeight: 'bold', color: '#ff0000' }}>
                                                <strong>{translator.translate('sandhills.registration.emailsuggesttext').replace('{0}?', ' ')}<span id='emailSuggestion' style={{ cursor: 'pointer', textDecoration: 'underline', color: 'black' }} role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onEmailSuggestionClick(); } }} onClick={onEmailSuggestionClick}>{emailSuggestion}</span>?</strong>
                                            </div>}
                                        {displayInquiryElement(inquiryType.EmailThis) &&
                                            <TextField
                                                type='text'
                                                id='recipientEmail'
                                                name='recipientEmail'
                                                value={recipientEmail}
                                                required={true}
                                                class='form-el'
                                                label={<TranslationText tKey='sandhills.recipientsemail' />}
                                                placeholder={translator.translate('sandhills.enterrecipientsemailaddress')}
                                                validationErrors={validationErrors.recipientEmail}
                                                ref={(element) => inputReferences.current[`recipientEmail`] = element}
                                                onFieldChanged={(e) => {
                                                    setRecipientEmail(e.target.value);
                                                    setValidationErrors((previousState) => {
                                                        return ({ ...previousState, recipientEmail: '' });
                                                    });
                                                }}
                                            />}
                                        {!displayInquiryElement(inquiryType.EmailThis) &&
                                            <>
                                                <TextField
                                                    type='text'
                                                    id='phone'
                                                    name='phone'
                                                    value={phone}
                                                    required={true}
                                                    class='form-el'
                                                    label={<TranslationText tKey='sandhills.phone' />}
                                                    validationErrors={validationErrors.phone}
                                                    ref={(element) => inputReferences.current[`phone`] = element}
                                                    onFieldChanged={(e) => {
                                                        setPhone(e.target.value);
                                                        setValidationErrors((previousState) => {
                                                            return ({ ...previousState, phone: '' });
                                                        });
                                                    }}
                                                />
                                                <TextField
                                                    type='text'
                                                    id='postalCode'
                                                    name='postalCode'
                                                    value={postalCode}
                                                    required={false}
                                                    class='form-el'
                                                    label={<TranslationText tKey='sandhills.postalcode' />}
                                                    placeholder={translator.translate('sandhills.enteryourpostalcode')}
                                                    validationErrors={validationErrors.postalCode}
                                                    ref={(element) => inputReferences.current[`postalCode`] = element}
                                                    onFieldBlur={(e) => {
                                                        if (e.target.value) {
                                                            postalCodeAjax({ 'postalCode': e.target.value.replace(/[^a-zA-Z0-9\-\ ]/g, "") });
                                                        }
                                                    }}
                                                    onFieldChanged={(e) => {
                                                        setPostalCode(e.target.value.replace(/[^a-zA-Z0-9\-\ ]/g, ""));
                                                        setValidationErrors((previousState) => {
                                                            return ({ ...previousState, postalCode: '' });
                                                        });
                                                    }}
                                                />
                                            </>}
                                    </div>
                                    <div className='right-col'>
                                        {displayInquiryElement(inquiryType.CheckAvailability) &&
                                            <div className='top-right'>
                                                <SelectField
                                                    id='inquiryTypeId'
                                                    name='inquiryTypeId'
                                                    value={inquiryTypeId}
                                                    options={inquiryOptions}
                                                    required={true}
                                                    hideLabel={false}
                                                    class='form-el'
                                                    label={<TranslationText tKey='sandhills.inquiry' />}
                                                    validationErrors={validationErrors.inquiryTypeId}
                                                    ref={(element) => inputReferences.current[`inquiryTypeId`] = element}
                                                    onFieldChanged={(e) => {
                                                        setInquiryTypeId(Number(e.target.value));
                                                        setComments(getInquiryComment(getSelectedInquiry(e.target.value)));
                                                        setValidationErrors((previousState) => {
                                                            return ({ ...previousState, inquiryTypeId: '' });
                                                        });
                                                    }}
                                                />
                                            </div>}
                                        {displayInquiryElement(inquiryType.Offer) &&
                                            <div className='top-right offer-amount-container'>
                                                <TextField
                                                    type='text'
                                                    id='offerAmount'
                                                    name='offerAmount'
                                                    value={offerAmount}
                                                    required={true}
                                                    class='form-el'
                                                    label={props.IsPreTrade && props.selectedInquiry == inquiryType.Offer ? translator.translate('sandhills.tradesites.mvc.pretradeoffer') : translator.translate('sandhills.tradepubwebsite.mvc.offeramount')}
                                                    placeholder={translator.translate('sandhills.listings.enterofferamount')}
                                                    validationErrors={validationErrors.offerAmount}
                                                    ref={(element) => inputReferences.current[`offerAmount`] = element}
                                                    onFieldChanged={(e) => {
                                                        setOfferAmount(e.target.value);
                                                        setValidationErrors((previousState) => {
                                                            return ({ ...previousState, offerAmount: '' });
                                                        });
                                                    }}
                                                />
                                                {!props.IsPreTrade &&
                                                    <CurrencySelector
                                                        {...props.CurrencySelector}
                                                        id='OfferCurrency'
                                                        name='OfferCurrency'
                                                        value={offerCurrency}
                                                        required='required'
                                                        className='valid currency-selector-dropdown'
                                                        containerClassName='form-el'
                                                        label={translator.translate('sandhills.tradepubwebsite.mvc.currency')}
                                                        ref={(element) => inputReferences.current[`OfferCurrency`] = element}
                                                        required
                                                        onChange={(value) => {
                                                            setOfferCurrency(value);
                                                            setValidationErrors((previousState) => {
                                                                return ({ ...previousState, offerCurrency: '' });
                                                            });
                                                        }}
                                                    />
                                                }
                                            </div>}
                                        {props.IsPreAT && !displayInquiryElement(inquiryType.VideoChat) &&
                                            <div className='top-right offer-amount-container'>
                                                <TextField
                                                    type='text'
                                                    id='offerAmount'
                                                    name='offerAmount'
                                                    value={offerAmount}
                                                    required={true}
                                                    class='form-el'
                                                    label={<TranslationText tKey='sandhills.tradesites.mvc.preatoffer' />}
                                                    placeholder={translator.translate('sandhills.listings.enterofferamount')}
                                                    validationErrors={validationErrors.offerAmount}
                                                    ref={(element) => inputReferences.current[`offerAmount`] = element}
                                                    onFieldChanged={(e) => {
                                                        setOfferAmount(e.target.value);
                                                        setValidationErrors((previousState) => {
                                                            return ({ ...previousState, offerAmount: '' });
                                                        });
                                                    }}
                                                />
                                                <CurrencySelector
                                                    {...props.CurrencySelector}
                                                    id='OfferCurrency'
                                                    name='OfferCurrency'
                                                    value={offerCurrency}
                                                    required='required'
                                                    className='valid currency-selector-dropdown'
                                                    containerClassName='form-el'
                                                    label={translator.translate('sandhills.tradepubwebsite.mvc.currency')}
                                                    ref={(element) => inputReferences.current[`OfferCurrency`] = element}
                                                    required
                                                    onChange={(value) => {
                                                        setOfferCurrency(value);
                                                        setValidationErrors((previousState) => {
                                                            return ({ ...previousState, offerCurrency: '' });
                                                        });
                                                    }}
                                                />
                                            </div>
                                        }
                                        {displayInquiryElement(inquiryType.VideoChat) &&
                                            <div className='video-chat-service-container'>
                                                <SelectField
                                                    id='videoChatService'
                                                    name='videoChatService'
                                                    value={videoChatService}
                                                    options={getVideoChatServices()}
                                                    required={true}
                                                    hideLabel={false}
                                                    class='form-el'
                                                    label={<TranslationText tKey='sandhills.videochatservice' />}
                                                    validationErrors={validationErrors.videoChatService}
                                                    ref={(element) => inputReferences.current[`videoChatService`] = element}
                                                    onFieldChanged={(e) => {
                                                        setVideoChatService(e.target.value);
                                                        setValidationErrors((previousState) => {
                                                            return ({ ...previousState, videoChatService: '' });
                                                        });
                                                    }}
                                                />
                                                <div className='video-chat-time-container'>
                                                    <div className='form-el'>
                                                        <label><span><TranslationText tKey='sandhills.whenwouldyouliketovideochat' /></span><span className='required'></span></label>
                                                        <div className='video-chat-datetime'>
                                                            <SelectField
                                                                id='videoChatTime'
                                                                name='videoChatTime'
                                                                value={videoChatTime}
                                                                options={getVideoChatTimes()}
                                                                required={true}
                                                                hideLabel={true}
                                                                validationErrors={validationErrors.videoChatTime}
                                                                ref={(element) => inputReferences.current[`videoChatTime`] = element}
                                                                onFieldChanged={(e) => {
                                                                    setVideoChatTime(e.target.value);
                                                                    setValidationErrors((previousState) => {
                                                                        return ({ ...previousState, videoChatTime: '' });
                                                                    });
                                                                }}
                                                            />
                                                            <SelectField
                                                                id='videoChatDay'
                                                                name='videoChatDay'
                                                                value={videoChatDay}
                                                                options={getVideoChatDays()}
                                                                required={true}
                                                                hideLabel={true}
                                                                validationErrors={validationErrors.videoChatDay}
                                                                ref={(element) => inputReferences.current[`videoChatDay`] = element}
                                                                onFieldChanged={(e) => {
                                                                    setVideoChatDay(e.target.value);
                                                                    setValidationErrors((previousState) => {
                                                                        return ({ ...previousState, videoChatDay: '' });
                                                                    });
                                                                }}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                        <TextField
                                            type='textarea'
                                            id='comments'
                                            name='comments'
                                            value={comments}
                                            required={true}
                                            class='form-el comment-element'
                                            label={<TranslationText tKey='sandhills.tradepubwebsite.mvc.message' />}
                                            placeholder={translator.translate('sandhills.EnterYourInquiry', [500])}
                                            validationErrors={validationErrors.comments}
                                            ref={(element) => inputReferences.current[`comments`] = element}
                                            onFieldChanged={(e) => {
                                                setComments(e.target.value);
                                                setValidationErrors((previousState) => {
                                                    return ({ ...previousState, comments: '' });
                                                });
                                            }}
                                        />
                                    </div>
                                </div>
                                <div className='form-bottom'>
                                    <div className='spacer'>
                                        <div className='cf'>
                                            <div className='column12 left'>
                                                <div className='inline inline-block'>
                                                    <div className='row consent-box' style={{ float: 'none' }}>
                                                        {emailSubAndAcknowledgement.WeeklyUpdateVisible &&
                                                            <div className='inline-block inline'>
                                                                <div className='inline-block inline consent-text'>
                                                                    <label htmlFor='SubscribeToWeeklyUpdate' className='visually-hidden'>{emailSubAndAcknowledgement.EmailSubText}</label>
                                                                    <input
                                                                        type='checkbox'
                                                                        name='SubscribeToWeeklyUpdate'
                                                                        id='SubscribeToWeeklyUpdate'
                                                                        checked={emailSubAndAcknowledgement.SubscribeToWeeklyUpdate}
                                                                        onChange={onEmailSubAndAcknowledgementChange}
                                                                        ref={(element) => inputReferences.current[`SubscribeToWeeklyUpdate`] = element}
                                                                    />
                                                                    &nbsp;
                                                                    <span style={{ color: validationErrors.SubscribeToWeeklyUpdate ? 'red' : '' }} dangerouslySetInnerHTML={{ __html: emailSubAndAcknowledgement.EmailSubText }}></span>
                                                                </div>
                                                                <br />
                                                                <br />
                                                            </div>}
                                                        {emailSubAndAcknowledgement.PixelsPolicyStatementVisible &&
                                                            <div id='pixels-policy-text' className='inline-block inline consent-text'>
                                                                <label htmlFor='PixelsPolicyAccepted' className='visually-hidden'>{emailSubAndAcknowledgement.PixelsPolicyText}</label>
                                                                <input
                                                                    type='checkbox'
                                                                    name='PixelsPolicyAccepted'
                                                                    id='PixelsPolicyAccepted'
                                                                    checked={emailSubAndAcknowledgement.PixelsPolicyAccepted}
                                                                    onChange={onEmailSubAndAcknowledgementChange}
                                                                    ref={(element) => inputReferences.current[`PixelsPolicyAccepted`] = element}
                                                                />
                                                                &nbsp;<span dangerouslySetInnerHTML={{ __html: emailSubAndAcknowledgement.PixelsPolicyText }} />
                                                            </div>}
                                                        <div className='clear' />
                                                        {emailSubAndAcknowledgement.PrivacyPolicyStatementVisible &&
                                                            <div id='privacy-policy-text' className='inline-block inline consent-text privacy-policy-error'>
                                                                <label htmlFor='PrivacyPolicyAccepted' className='visually-hidden'>{emailSubAndAcknowledgement.PrivacyPolicyText}</label>
                                                                {emailSubAndAcknowledgement.PrivacyPolicyIsCheckbox &&
                                                                    <>
                                                                        <input
                                                                            required
                                                                            type='checkbox'
                                                                            name='PrivacyPolicyAccepted'
                                                                            id='PrivacyPolicyAccepted'
                                                                            className='input-validation-error error'
                                                                            checked={emailSubAndAcknowledgement.PrivacyPolicyAccepted}
                                                                            onChange={onEmailSubAndAcknowledgementChange}
                                                                            ref={(element) => inputReferences.current[`PrivacyPolicyAccepted`] = element}
                                                                    />
                                                                    &nbsp;<span className='required' />
                                                                    </>}
                                                                <span dangerouslySetInnerHTML={{ __html: emailSubAndAcknowledgement.PrivacyPolicyText }} />
                                                                {validationErrors.PrivacyPolicyAccepted && <div className='error'>{validationErrors.PrivacyPolicyAccepted}</div>}
                                                            </div>}
                                                        {emailSubAndAcknowledgement.InternationalLegalStatement &&
                                                            <div className='international-legal-statement' dangerouslySetInnerHTML={{ __html: emailSubAndAcknowledgement.InternationalLegalStatement }} style={{ marginTop: '10px' }} />}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='captcha-and-submit'>
                                        <div className='captcha-placeholder'>
                                            {props.Captcha &&
                                                <SandhillsReCAPTCHA
                                                    ref={recaptchaRef}
                                                    sitekey={props.Captcha.Key}
                                                    onChange={onSubmit}
                                                    onCaptchaClosedBeforeCompletion={resetModal}
                                                    captchaOpen={captchaOpen}
                                                />}
                                            <button disabled={disableSubmit} className='g-recaptcha button ts-button' type='submit'><TranslationText tKey='sandhills.tradepubwebsite.mvc.submit' /></button>
                                        </div>
                                    </div>
                                </div>
                            </form>}
                        {disableModal && <LoadingRing backdrop />}
                    </Modal.Body>
                </>}
        </Modal>
    );
};

export default EmailModal;